export const PLACEHOLDER_USER_IMAGE =
  'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png';

export const isToolEnabled = process.env.REACT_APP_ENABLE_TOOL === 'true';
export const isFaqEnabled = process.env.REACT_APP_ENABLE_FAQ === 'true';
